<form [formGroup]="supplierForm" (ngSubmit)="onSubmitSupplierForm()">
  <div class="modal-body row g-3">
    <div class="col-md-6">
      <label>
        Supplier Name
        <span class="text-danger">*</span>
      </label>
      <input type="text" class="form-control" formControlName="name" />
      <div
        *ngIf="supplierForm.get('name')?.touched && supplierForm.get('name')?.invalid"
        class="text-danger small mt-1">
        Supplier name is required.
      </div>
    </div>

    <div class="col-md-6">
      <label>Responsible Person</label>
      <input type="text" class="form-control" formControlName="responsible_person" />
    </div>

    <div class="col-md-6">
      <label>Email</label>
      <input type="email" class="form-control" formControlName="email" />
      <div
        *ngIf="supplierForm.get('email')?.touched && supplierForm.get('email')?.errors?.['email']"
        class="text-danger small mt-1">
        Enter a valid email address.
      </div>
    </div>

    <div class="col-md-6">
      <label>Contact Number</label>
      <input type="text" class="form-control" formControlName="phone_number" />
    </div>

    <div class="col-md-6">
      <label>GST Number</label>
      <input type="text" class="form-control" formControlName="gst_number" />
    </div>

    <div class="col-md-6">
      <label>PAN Number</label>
      <input type="text" class="form-control" formControlName="pan_card_number" />
    </div>

    <div class="col-md-6">
      <label>Udyam Registration</label>
      <input type="text" class="form-control" formControlName="udyam_number" />
    </div>

    <div class="col-md-6">
      <label>Address</label>
      <input type="text" class="form-control" formControlName="address" />
    </div>

    <div class="col-md-6">
      <label>Firm Type</label>
      <ng-select
        placeholder="Select Firm Type"
        [items]="firmTypeOptions"
        formControlName="firm_type"
        bindValue="value"
        bindLabel="label"
        [clearable]="true"
        [searchable]="false" />
    </div>

    <div class="col-md-6">
      <div class="d-flex justify-content-between align-items-center">
        <label class="mb-0">
          Category
          <span class="text-muted small fw-normal">(optional)</span>
        </label>
        @if (!isCreatingCategory) {
          <button type="button" class="btn btn-link btn-sm p-0" (click)="startCreatingCategory()">
            <i class="bi bi-plus-circle me-1"></i>
            New category
          </button>
        }
      </div>

      <ng-select
        placeholder="No category"
        [items]="categories"
        formControlName="category"
        bindValue="id"
        bindLabel="name"
        [clearable]="true"
        [searchable]="true" />

      <!-- Inline creation, so classifying a supplier never means leaving this dialog -->
      @if (isCreatingCategory) {
        <!-- Enter adds the category rather than submitting the supplier behind it -->
        <div
          class="new-category-panel mt-2"
          [formGroup]="newCategoryForm"
          (keydown.enter)="$event.preventDefault(); saveNewCategory()">
          <label for="newCategoryName" class="form-label small mb-1">New category name</label>
          <input
            type="text"
            id="newCategoryName"
            class="form-control form-control-sm shadow-none"
            formControlName="name"
            maxlength="255"
            placeholder="e.g. Chemicals"
            [class.is-invalid]="
              (newCategoryForm.get('name')?.invalid && newCategoryForm.get('name')?.touched) || !!categoryNameError
            "
            (input)="categoryNameError = null" />
          @if (newCategoryForm.get('name')?.touched && newCategoryForm.get('name')?.errors?.['required']) {
            <div class="text-danger small mt-1">Name is required.</div>
          } @else if (categoryNameError) {
            <div class="text-danger small mt-1">{{ categoryNameError }}</div>
          }

          @if (categoryCreateError) {
            <app-error-alert class="d-block mt-2" [error]="categoryCreateError"></app-error-alert>
          }

          <div class="d-flex justify-content-end gap-2 mt-2">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              (click)="cancelCreatingCategory()"
              [disabled]="isSavingCategory">
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              (click)="saveNewCategory()"
              [disabled]="isSavingCategory">
              @if (isSavingCategory) {
                <span class="spinner-border spinner-border-sm me-1"></span>
                Adding...
              } @else {
                Add category
              }
            </button>
          </div>
        </div>
      }
    </div>

    @if (submitError) {
      <div class="col-12">
        <app-error-alert [error]="submitError"></app-error-alert>
      </div>
    }
  </div>

  <div class="modal-footer">
    <button
      type="submit"
      class="btn btn-primary btn-enjochem"
      [disabled]="supplierForm.invalid || isCreatingCategory"
      [title]="isCreatingCategory ? 'Finish adding the category first' : ''">
      <ng-container *ngIf="isSupplierDataSaving; else saveIcon">
        <app-loading-spinner [inline]="true" class="me-1"></app-loading-spinner>
      </ng-container>
      <ng-template #saveIcon>
        <i class="bi bi-check-circle"></i>
      </ng-template>
      <span>Save</span>
    </button>
    <button type="button" class="btn btn-secondary" (click)="onCancel()">
      <i class="bi bi-arrow-left-circle"></i>
      <span>Cancel</span>
    </button>
  </div>
</form>
